<script setup lang="ts">
withDefaults(
  defineProps<{
    closable?: boolean
    type?: 'success' | 'warning' | 'info' | 'primary' | 'danger'
    variant?: 'success' | 'danger' | 'primary' | 'warning'
    extraClass?: string
    size?: 'large' | 'default' | 'small'
  }>(),
  { closable: false, type: 'primary', extraClass: '', size: 'default' },
)
defineEmits(['close'])
</script>
<template>
  <div>
    <el-tag
      :closable="closable"
      :disable-transitions="true"
      :type="type"
      :size="size"
      :class="extraClass || variant"
      @close="$emit('close')"
    >
      <slot />
    </el-tag>
  </div>
</template>
<style lang="scss" scoped>
:deep(.el-tag) {
  cursor: default;
  border-radius: 8px;
  height: 36px;

  .el-icon {
    width: 18px;
    height: 18px;
  }

  &.el-tag--small {
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
    border-radius: 4px;
  }

  &.success {
    color: var(--inverted);
    background-color: var(--success);
    border: 1px solid var(--success);
  }

  &.warning {
    color: var(--inverted);
    background-color: var(--warning);
    border: 1px solid var(--warning);
  }

  &.danger {
    color: var(--inverted);
    background-color: var(--alert);
    border: 1px solid var(--alert);
  }

  &.primary {
    color: var(--inverted);
    background-color: #b8b8b8;
    border: 1px solid #b8b8b8;
  }
}

:deep(.el-tag--info) {
  color: var(--primary);
  background-color: var(--inverted);
  border: 1px solid var(--secondary-12);
}
:deep(.el-tag__content) {
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
}
</style>
